import { Component } from '@theme/component';

for (const journey of document.querySelectorAll('jv-journey')) {
  const target = journey.dataset.jvPlacement ? document.querySelector(journey.dataset.jvPlacement) : null;
  const wrapper = journey.closest('.shopify-section');
  if (target && wrapper && !wrapper.contains(target)) target.before(wrapper);
}

class JVJourney extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.details = this.querySelector('details');
    this.scene = this.querySelector('[data-jv-scene]');
    this.portrait = this.querySelector('[data-jv-portrait]');
    this.response = this.querySelector('[data-jv-response]');
    this.next = this.querySelector('[data-jv-next]');
    this.back = this.querySelector('[data-jv-back]');
    this.labels = JSON.parse(this.querySelector('[data-jv-poses]').textContent);
    this.querySelector('.jv-play').hidden = false;
    this.showChapter(0, false);
    this.details.addEventListener('toggle', () => {
      if (this.details.open) this.focusChapter();
    }, { signal });
    this.addEventListener('click', this.handleClick, { signal });
  }

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const choice = event.target.closest('[data-jv-choice]');
    if (choice && !choice.disabled) {
      this.scene.querySelector('.jv-choices').hidden = true;
      this.response.textContent = choice.dataset.reply;
      this.response.hidden = false;
      this.next.hidden = false;
      this.setPose(Number(choice.dataset.pose));
      this.next.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('jv:choice', { bubbles:true, detail:{ character:this.dataset.jvCharacter || 'jv', chapter:this.chapter, choice:choice.dataset.jvChoice } }));
      return;
    }
    if (event.target.closest('[data-jv-next]')) this.showChapter(this.chapter + 1);
    if (event.target.closest('[data-jv-back]')) this.showChapter(this.chapter - 1);
    if (event.target.closest('[data-jv-replay]')) this.showChapter(0);
  };

  showChapter(chapter, focus = true) {
    if (chapter < 0 || chapter > 4) return;
    this.chapter = chapter;
    this.dataset.chapter = String(chapter);
    this.scene.replaceChildren(this.querySelector(`[data-jv-template="${chapter}"]`).content.cloneNode(true));
    this.response.hidden = true;
    this.response.textContent = '';
    this.next.hidden = true;
    this.back.hidden = chapter === 0;
    this.querySelectorAll('[data-jv-dot]').forEach((dot, index) => {
      dot.toggleAttribute('data-complete', index <= chapter);
      if (index === chapter) dot.setAttribute('aria-current', 'step');
      else dot.removeAttribute('aria-current');
    });
    this.setPose([0, 1, 2, 4, 5][chapter], true);
    this.querySelector('.jv-stage-number').textContent = this.dataset.jvCharacter ? String(chapter + 1).padStart(2,'0') : chapter === 4 ? '1' : '48';
    if (focus) this.focusChapter();
  }

  setPose(pose, exact = false) {
    if (!exact && Number(this.portrait.dataset.pose) === pose) pose = pose === 2 ? 3 : 2;
    this.portrait.dataset.pose = String(pose);
    this.portrait.setAttribute('aria-label', this.labels[pose]);
    this.portrait.classList.remove('is-reacting');
    cancelAnimationFrame(this.motionFrame);
    this.motionFrame = requestAnimationFrame(() => this.portrait.classList.add('is-reacting'));
  }

  focusChapter() {
    const heading = this.scene.querySelector('h2');
    heading?.focus({ preventScroll:true });
    if (this.details.open && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block:'start', behavior:'instant' });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.motionFrame);
    super.disconnectedCallback();
  }
}

if (!customElements.get('jv-journey')) customElements.define('jv-journey', JVJourney);
